/** Internal dependencies */
import whenDocumentReady from '../../../../../assets/src/scripts/utilities/whenDocumentReady';

whenDocumentReady(initWidget);

function initWidget() {
    const navItems = document.querySelectorAll('.ct_navigation .nav-item');

    if (!navItems) {
        return;
    }

    const megamenuNavs = document.querySelectorAll('.ct_navigation.megamenu');

    if (megamenuNavs) {
        const header = document.querySelector('.main-container > header');

        if (header) {
            header.addEventListener('mouseleave', handleHeaderLeave);
        }

        megamenuNavs.forEach((nav) => {
            nav.classList.add('initialized');
        });
    }

    navItems.forEach((navItem) => {
        navItem.addEventListener('mouseenter', handleNavItemHover);

        // mouseleave on nav item only for default nav
        if (navItem.closest('.ct_navigation.default')) {
            navItem.addEventListener('mouseleave', handleNavItemLeave);
        }
    });
}

function handleNavItemHover(e) {
    const navItem = e.currentTarget;
    closeDropdowns(navItem);

    if (navItem.classList.contains('dropdown')) {
        navItem.classList.add('show');
        navItem.setAttribute('aria-expanded', 'true');

        const menu = navItem.querySelector('.dropdown-menu');
        if (menu) {
            menu.classList.add('show');
            menu.setAttribute('aria-expanded', 'true');
        }
    }
}

function handleNavItemLeave(e) {
    const navItem = e.currentTarget;
    closeDropdowns(navItem);
}

function handleHeaderLeave(e) {
    const header = e.currentTarget;

    // get a random nav item in our mega menu
    const navItem = header.querySelector('.ct_navigation.megamenu .nav-item');
    closeDropdowns(navItem);
}

function closeDropdowns(navItem) {
    // remove previously opened dropdowns
    const dropdowns = navItem.parentElement.querySelectorAll('.dropdown');
    const dropdownMenus = navItem.parentElement.querySelectorAll('.dropdown-menu');

    if (dropdowns) {
        dropdowns.forEach((dropdown) => {
            dropdown.setAttribute('aria-expanded', 'false');
            dropdown.classList.remove('show');
        });
    }

    if (dropdownMenus) {
        dropdownMenus.forEach((menu) => {
            menu.setAttribute('aria-expanded', 'false');
            menu.classList.remove('show');
        });
    }
}
